"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _rangyCore = _interopRequireDefault(require("rangy/lib/rangy-core.js"));
require("rangy/lib/rangy-classapplier.js");
require("rangy/lib/rangy-highlighter.js");
require("rangy/lib/rangy-textrange.js");
require("rangy/lib/rangy-serializer.js");
var _isOpenBook = _interopRequireDefault(require("../helpers/isOpenBook.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var HighlightHooks = /*#__PURE__*/_createClass(function HighlightHooks(_ref) {
  var _this = this;
  var Highlights = _ref.Highlights;
  _classCallCheck(this, HighlightHooks);
  this.highlights = Highlights;
  this.useHighlight = function (quiz, questionId) {
    var highlight = quiz.getIn(['highlights', questionId]);
    var question = (0, _reactRedux.useSelector)(function (state) {
      return state.questions.get(questionId);
    });
    var highlighterRef = (0, _react.useRef)();
    var dispatch = (0, _reactRedux.useDispatch)();
    var inPracticeBreak = quiz.get('isPractice') && !quiz.get('inQuestionBlock');
    var syncHighlight = function syncHighlight() {
      // Remove scopes from rangy highlights before serializing.
      // This wouldn't be necessary if the iFrames used for Question Stems in the mobile app shared a common root
      // HTML element with the same ID as what we use in App 2.0. Unfortunately the data already exists without
      // this `containerElementId` property so we would have to implement a function to check for and add it in
      // to maintain backwards compatability with existing User Highlights.
      highlighterRef.current.highlights.forEach(function (h) {
        // Unscope highlights for the Question stem (backwards compatability)
        if (h.containerElementId === 'QuizQuestion-question-name') {
          h.containerElementId = null;
        }
      });
      dispatch(_this.highlights.highlightSync(quiz.get('id'), questionId, highlighterRef.current.serialize()));
    };
    var onClickHighlightOn = function onClickHighlightOn(highlightTypeArg) {
      var highlightType = highlightTypeArg ? "highlight-".concat(highlightTypeArg) : 'highlight';

      // Create a scoped highlight for the selected text across several elements.
      var elementIds = ['question-name'];
      if ((0, _isOpenBook.default)(quiz.get('type')) || quiz.get('status') === 'complete') {
        elementIds.push('explanation');
        if (question.get('safe_reference')) elementIds.push('reference');
      }
      if (question.get('type') === 'MultipleChoiceQuestion') {
        question.get('answers').forEach(function (answer) {
          return elementIds.push("answer-".concat(answer.get('id')));
        });
      }

      // highlightSelection resets selection ranges so we have to save them before starting and restore between each element.
      var selection = _rangyCore.default.getSelection();
      var ranges = selection.saveRanges();
      var selectedElementIds = elementIds.filter(function (elementId) {
        return selection.containsNode(document.getElementById("QuizQuestion-".concat(elementId)), true);
      });
      selectedElementIds.forEach(function (elementId) {
        selection.restoreRanges(ranges);
        highlighterRef.current.highlightSelection(highlightType, {
          selection: selection,
          containerElementId: "QuizQuestion-".concat(elementId)
        });
      });

      // Unselect selected text
      selection.removeAllRanges();
      syncHighlight();
    };
    var onClickHighlightOff = function onClickHighlightOff() {
      highlighterRef.current.unhighlightSelection();
      syncHighlight();
    };

    // Add a highlight if there are no highlights in the current selection,
    // otherwise remove highlights that intersect the current selection.
    var onClickHighlightToggle = function onClickHighlightToggle(highlightTypeArg) {
      var _highlighterRef$curre, _rangyCore$default$ge;
      var selectedHighlights = (_highlighterRef$curre = highlighterRef.current) === null || _highlighterRef$curre === void 0 ? void 0 : _highlighterRef$curre.getIntersectingHighlights((_rangyCore$default$ge = _rangyCore.default.getSelection()) === null || _rangyCore$default$ge === void 0 ? void 0 : _rangyCore$default$ge.getAllRanges());
      if ((selectedHighlights === null || selectedHighlights === void 0 ? void 0 : selectedHighlights.length) > 0) {
        onClickHighlightOff();
      } else {
        onClickHighlightOn(highlightTypeArg);
      }
    };

    // Reset highlighter when question changes
    (0, _react.useEffect)(function () {
      // Initialize Rangy if needed
      if (!_rangyCore.default.initialized) _rangyCore.default.init();
      highlighterRef.current = _rangyCore.default.createHighlighter();
      var highlighterTypes = ['', 'green', 'peach', 'blue', 'red', 'strikethrough'];
      highlighterTypes.forEach(function (highlighterType) {
        return highlighterRef.current.addClassApplier(_rangyCore.default.createClassApplier("highlight".concat(highlighterType ? "-".concat(highlighterType) : ''), {
          ignoreWhiteSpace: true,
          tagNames: ["span", "a"]
        }));
      });
    }, [questionId]);
    (0, _react.useEffect)(function () {
      if (!highlight || inPracticeBreak) return;

      // Re-scope Highlights to target element
      // This wouldn't be necessary if the iFrames used for Question Stems in the mobile app shared a common root
      // HTML element with the same ID as what we use in App 2.0. Unfortunately the data already exists without
      // this `containerElementId` property so we would have to implement a function to check for and add it in
      // to maintain backwards compatability with existing User Highlights.

      var highlighter = highlighterRef.current;
      var highlightRanges = highlight.get('ranges').split('|');
      for (var i = 1; i < highlightRanges.length; i += 1) {
        // Unscoped highlights belong to the Question stem
        if (highlightRanges[i][highlightRanges[i].length - 1] === '$') {
          highlightRanges[i] += 'QuizQuestion-question-name';
        }
        // Guarding against highlights for answers that belong to a different question and cause a crash when deserializing
        if (highlightRanges[i].includes('answer-')) {
          (function () {
            var _question$get;
            var answerId = highlightRanges[i].split('answer-')[1];
            var answer = question === null || question === void 0 ? void 0 : (_question$get = question.get('answers')) === null || _question$get === void 0 ? void 0 : _question$get.find(function (a) {
              return a.get('id') === parseInt(answerId);
            });
            if (!answer) {
              highlightRanges.splice(i, 1);
              i--;
            }
          })();
        }
      }
      var highlightStr = highlightRanges.join('|');
      highlighter.deserialize(highlightStr);
    }, [highlight]);
    return {
      onClickHighlightOff: onClickHighlightOff,
      onClickHighlightOn: onClickHighlightOn,
      onClickHighlightToggle: onClickHighlightToggle
    };
  };
});
var _default = exports.default = HighlightHooks;